/* eslint-disable formatjs/no-literal-string-in-jsx */
/* eslint-disable react/jsx-no-literals */
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const LoadingDots = ({ message = '', style = {} }) => (
  <div style={style} className="loading-overlay">
    <div className="loading-content">
      <h2>
        {message || <FormattedMessage defaultMessage="Please Wait" />}
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </h2>
    </div>
  </div>
);

LoadingDots.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
};

export default LoadingDots;
